import styled from 'styled-components'
import LoginScreen from '../../assets/images/Login/LoginImage.svg'

export const Container = styled.div`
  background: linear-gradient(180deg, #0384b9 0%, #150d49 100%);
  height: 100vh;
  width: 100vw;
  display: flex;
  gap: 1rem;
`

export const LoginImage = styled.div`
  height: 100%;
  width: 60%;
  display: flex;
  background-image: url(${LoginScreen});
  background-size: cover;
  background-repeat: no-repeat;
`

export const Content = styled.form`
  height: 100%;
  width: 40%;
  background-color: ${(props) => props.theme.color.neutral.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`

export const MainContent = styled.div`
  height: calc(100% - 20rem);
  width: 55%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;
  top: 0;
  justify-content: center;
`

export const LogoImage = styled.img`
  height: 4.5rem;
  width: auto;
  font-size: ${(props) => props.theme.font.textcaption};
`

export const ButtonContainer = styled.div`
  width: 100%;
`

export const LoginFooter = styled.div`
  height: 2rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.color.blue.blue100};
  position: absolute;
  bottom: 0;
`

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.125rem;
  width: 100%;
`

export const Link = styled.a`
  font-size: ${(props) => props.theme.font.textcaption};
  color: ${(props) => props.theme.color.purple.base};
  font-weight: 400;
  cursor: pointer;
  outline: none;
  text-decoration: none;
`
